import { client } from "api";
import { CustomerApproval } from "models/Order";

export type EditReasonRequest = { approvalId: string; reason: string };
export type EditReasonResponse = CustomerApproval;

export const editReason = ({ approvalId, reason }: EditReasonRequest) =>
  client
    .put<EditReasonResponse>(`/approve/reason/${approvalId}`, { reason })
    .then((res) => res.data);
